import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './App';
import Modal from 'react-modal';
import { login, logout } from './redux/actions/authActions';

// Set the app element for react-modal accessibility
Modal.setAppElement('#root');

// Initialize authentication state on app load
const initializeAuth = async () => {
  const existingToken = localStorage.getItem('authToken');
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';

  if (existingToken && isAuthenticated) {
    // If we have a stored token, initialize the auth state
    store.dispatch(login(existingToken));
    try {
      const { fetchUserData } = await import('./redux/actions/authActions');
      await store.dispatch(fetchUserData());
    } catch (error) {
      // If token is invalid, clear auth state
      if (error.message?.includes('401') || error.response?.status === 401) {
        store.dispatch(logout());
      }
    }
  }
};

// Initialize auth state
initializeAuth();

// React 18 API
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
